const QuestionUsageType = {
  Pinned: "pinned",
  Engagement: "engagement",
  Value: "value",
  Profile: "profile",
};

export default QuestionUsageType;
